module.exports = __webpack_public_path__ + "media/images/avatar-upload-243fd9f5a93164b1d4890298021e3cd1.png";